
import $ from 'jquery'

export default function () {
  var $inputCustom = $('.input--custom')
  var $fieldsetCustom = $('.fieldset--custom')
  var fieldsetFocusClass = 'fieldset--custom--focus'
  var fieldsetFilledClass = 'fieldset--custom--filled'
  var fieldsetCustomClass = '.fieldset--custom'

  // Input labels
  $inputCustom.focusout(function () {
    $fieldsetCustom.removeClass(fieldsetFocusClass)
  })
  $inputCustom.focus(function () {
    $(this).closest(fieldsetCustomClass).addClass(fieldsetFocusClass)
  })

  $inputCustom.blur(function () {
    if ($(this).val()) {
      $(this).closest(fieldsetCustomClass).addClass(fieldsetFilledClass)
    } else {
      $(this).closest(fieldsetCustomClass).removeClass(fieldsetFilledClass)
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/lib/floated-label.js